export default __webpack_public_path__ + "static/media/project1.abe50296.png";